import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";

import {
  AuthProvider,
  useAuth,
} from "./context/AuthContext";

import Navbar from "./components/Navbar";

import Home from "./pages/Home";
import Signup from "./pages/Signup";
import Login from "./pages/Login";
import UserProfile from "./pages/UserProfile";
import HostProfile from "./pages/HostProfile";
import EditProfile from "./pages/EditProfile";
import Hosts from "./pages/Hosts";
import Activities from "./pages/Activities";
import CreateEvent from "./pages/CreateEvent";
import Events from "./pages/Events";
import EventDetails from "./pages/EventDetails";
import HostDashboard from "./pages/HostDashboard";
import EditEvent from "./pages/EditEvent";
import InterestedUsers from "./pages/InterestedUsers";
import MyInterestedEvents from "./pages/MyInterestedEvents";
import Notifications from "./pages/Notifications";
import BookingRequests from "./pages/BookingRequests";
import MyBookings from "./pages/MyBookings";
import EditPackageGallery from "./pages/EditPackageGallery";
import HostBookings from "./pages/HostBookings";
import ExploreMap from "./pages/ExploreMap";
import AddPlace from "./pages/AddPlace";
import PlaceDetails from "./pages/PlaceDetails";
import AdminExplore from "./pages/AdminExplore";
import AdminLogin from "./pages/AdminLogin";
import BlockedAccount from "./pages/BlockedAccount";
import Agent from "./pages/Agent";
import HostDemandDetails from "./pages/HostDemandDetails";
import AdventureRequestDetails from "./pages/AdventureRequestDetails";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import CookiePolicy from "./pages/CookiePolicy";
import TermsOfUse from "./pages/TermsOfUse";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import HostTerms from "./pages/HostTerms";
import Safety from "./pages/Safety";
import Stays from "./pages/Stays";
import DeleteAccount from "./pages/DeleteAccount";
import Marketplace from "./pages/Marketplace";
import MyOffers from "./pages/MyOffers";
import MyRequests from "./pages/MyRequests";
import CreateRequest from "./pages/CreateRequest";

// NOVO
import AccommodationDetails from "./pages/AccommodationDetails";
import ServiceDetails from "./pages/ServiceDetails";
import RentalDetails from "./pages/RentalDetails";

function AppRoutes() {
  const {
    loading,
    isBanned,
    isSuspended,
    needsHostProfileCompletion,
    isAdmin,
  } = useAuth();

  const location = useLocation();

  const isAdminLogin = location.pathname === "/admin-login";
  const isAdminArea = location.pathname.startsWith("/admin/");
  const hideNavbar = isAdminLogin || isAdminArea;

  if (
    !loading &&
    (isBanned || isSuspended) &&
    location.pathname !== "/blocked" &&
    !isAdminLogin
  ) {
    return <Navigate to="/blocked" replace />;
  }

  // Jedina nova zaštita: nepotpuni host mora prvo da završi profil.
  // Ne preusmerava dok se autentifikacija učitava, niti sa same stranice
  // za uređivanje. Postojeći admin tok ostaje dostupan administratorima.
  const hostCompletionExempt =
    location.pathname === "/edit-profile" ||
    location.pathname === "/blocked" ||
    location.pathname === "/delete-account" ||
    location.pathname === "/reset-password" ||
    isAdminLogin ||
    (isAdmin && isAdminArea);

  if (
    !loading &&
    !isBanned &&
    !isSuspended &&
    needsHostProfileCompletion &&
    !hostCompletionExempt
  ) {
    return <Navigate to="/edit-profile" replace />;
  }

  return (
    <>
      {!hideNavbar && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/register" element={<Navigate to="/signup" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
        <Route path="/admin" element={<Navigate to="/admin/explore" replace />} />
        <Route path="/cookies" element={<CookiePolicy />} />
        <Route path="/blocked" element={<BlockedAccount />} />
        <Route path="/u/:username" element={<UserProfile />} />
        <Route path="/h/:username" element={<HostProfile />} />
        <Route path="/my-offers" element={<MyOffers />} />
        <Route path="/edit-profile" element={<EditProfile />} />
        <Route path="/my-requests" element={<MyRequests />} />
        <Route path="/hosts" element={<Hosts />} />
        <Route path="/activities" element={<Activities />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/host-terms" element={<HostTerms />} />
        <Route path="/safety" element={<Safety />} />
        <Route path="/create-event" element={<CreateEvent />} />
        <Route path="/terms" element={<TermsOfUse />} />
        <Route path="/events" element={<Events />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/marketplace" element={<Marketplace />} />
        <Route path="/event/:id" element={<EventDetails />} />
        {/* NOVO - SMEŠTAJ */}
        <Route path="/accommodation/:id" element={<AccommodationDetails />} />
        {/* NOVO - USLUGE */}
        <Route path="/service/:id" element={<ServiceDetails />} />
        {/* NOVO - IZNAJMLJIVANJE */}
        <Route path="/rental/:id" element={<RentalDetails />} />
        <Route path="/dashboard" element={<HostDashboard />} />
        <Route path="/edit-event/:id" element={<EditEvent />} />
        <Route path="/event/:id/interested" element={<InterestedUsers />} />
        <Route path="/my-events" element={<MyInterestedEvents />} />
        <Route path="/stays" element={<Stays />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/host/demand/:id" element={<HostDemandDetails />} />
        <Route path="/agent/request/:id" element={<AdventureRequestDetails />} />
        <Route path="/booking-requests" element={<BookingRequests />} />
        <Route path="/my-bookings" element={<MyBookings />} />
        <Route
  path="/create-request"
  element={<CreateRequest />}
/>
        <Route path="/edit-package/:id/gallery" element={<EditPackageGallery />} />
        <Route path="/host-bookings" element={<HostBookings />} />
        <Route path="/explore" element={<ExploreMap />} />
        <Route path="/agent" element={<Agent />} />
        <Route path="/explore/add" element={<AddPlace />} />
        <Route path="/mesta/:slug" element={<PlaceDetails />} />
        <Route path="/explore/:id" element={<PlaceDetails />} />
        <Route path="/admin/explore" element={<AdminExplore />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
